// Chakra imports
import {
  Button,
  Flex,
  Text,
  useColorModeValue,
  Divider,
  Box,
} from '@chakra-ui/react';
import { Link as Chakralink } from '@chakra-ui/react';
// Custom components
import Card from 'components/card/Card.js';
// Assets
import React from 'react';
import { useHistory, Link } from 'react-router-dom';

export default function SavingsPlanCard(props) {
  const { data } = props;
  console.log('Data recieved Sam', data);
  const { id, name, is_active, category, metal_type } = data;
  // const status = 'INACTIVE';
  const btnVariant = useColorModeValue('brand');
  const textColor = useColorModeValue('navy.700', 'white');
  const textColorAddress = useColorModeValue('brand.500', 'whiteAlpha.800');
  return (
    <Card
      p='20px'
      maxW={{ md: 'md', '3xl': 'lg' }}>
      <Flex
        direction={{ base: 'column' }}
        justify='center'>
        <Flex
          flexDirection='column'
          justify='space-between'
          h='100%'>
          <Flex
            justify='space-between'
            // direction={{
            //   base: 'row',
            //   md: 'column',
            //   lg: 'row',
            //   xl: 'column',
            //   '2xl': 'row',
            // }}
            direction='column'
            mb='auto'>
            <Flex
              direction='column'
              mb='20px'>
              <Flex
                direction='row'
                justify='space-between'>
                <Text
                  color={textColor}
                  fontSize={{
                    base: 'xl',
                    md: 'lg',
                    lg: 'lg',
                    xl: 'lg',
                    '2xl': 'lg',
                    '3xl': 'lg',
                  }}
                  mb='5px'
                  fontWeight='bold'
                  me='14px'>
                  {name}
                </Text>
                <Box
                  backgroundColor={is_active ? 'green' : 'red'}
                  width='10px'
                  height='10px'
                  borderRadius='5px'></Box>
              </Flex>
              <Text
                color='secondaryGray.600'
                fontSize={{
                  base: 'sm',
                }}
                fontWeight='400'
                me='14px'
                mb='4'>
                {is_active ? 'ACTIVE' : 'INACTIVE'}
              </Text>
              <Divider />
            </Flex>
          </Flex>
          <Flex
            align='start'
            justify='space-between'
            direction={{
              base: 'row',
              md: 'column',
              lg: 'row',
              xl: 'column',
              '2xl': 'row',
            }}
            mt='25px'>
            <Text
              fontWeight='700'
              fontSize='sm'
              mb='60px'
              color={textColorAddress}>
              Type : {metal_type}
            </Text>
            <Chakralink
              position='absolute'
              bottom='14px'
              right='14px'
              mt={{
                base: '0px',
                md: '10px',
                lg: '0px',
                xl: '10px',
                '2xl': '0px',
              }}>
              <Link
                to={{
                  pathname: `/admin/savingplan/${id}`,
                }}>
                <Button
                  variant={btnVariant}
                  color='white'
                  fontSize='sm'
                  fontWeight='500'
                  borderRadius='10px'
                  px='15px'
                  py='5px'>
                  Plan Details
                </Button>
              </Link>
            </Chakralink>
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
}
